import { writable } from 'svelte/store'

export const userActive = writable(false)

export const documents = writable([])

export const signedDocuments = writable([])